export default __webpack_public_path__ + "static/media/per-cb.099a60ee.svg";